import { makeAutoObservable, runInAction } from "mobx";
import { getAuth, onAuthStateChanged } from "firebase/auth";

export function createRolesStore() {
  const store = makeAutoObservable({
    claims: null,
    isLoaded: false,

    get isSuperAdmin() {
      return this.claims?.superAdmin === true;
    },

    setClaims(claims) {
      this.claims = claims;
      this.isLoaded = true;
    },
  });

  onAuthStateChanged(getAuth(), async (user) => {
    const result = user ? await user.getIdTokenResult() : null;

    runInAction(() => store.setClaims(result?.claims ?? null));
  });

  return store;
}
